import {
  Box, Stack,
} from '@mui/material'
import React from 'react'
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from 'recharts'

import ChartLabel from '../components/Label'

import {
  Cell,
  TopPrivacyIssueStat,
} from './types'

// The neutral token ResultsCard paints a `color='grey'` (N/A) card with.
const NOT_APPLICABLE_COLOR = '#CCC'

function ChartsPrivacy({ data }: { data: TopPrivacyIssueStat[]}) {
  function buildData() {
    const questionsWithGoodPractice:Cell[] = []
    const questionsWithBadPractice:Cell[] = []
    const questionsWithUnclearPractice:Cell[] = []
    const questionsNotApplicable:Cell[] = []

    function getTarget(score: number) {
      if (score >= 1) {
        return questionsWithGoodPractice
      }
      if (score >= 0.5) {
        return questionsWithBadPractice
      }

      return questionsWithUnclearPractice
    }

    data.forEach(({
      score, isNotApplicable,
    }, y) => {
      // An N/A issue scores 0, so without this branch it would plot as an orange "Unclear"
      // point - the same score-vs-flag confusion the summary counters avoid.
      const target = isNotApplicable ? questionsNotApplicable : getTarget(score)
      target.push({
        x: score,
        y,
      })
    })

    return {
      questionsWithGoodPractice,
      questionsWithBadPractice,
      questionsWithUnclearPractice,
      questionsNotApplicable,
    }
  }

  const {
    questionsWithGoodPractice,
    questionsWithBadPractice,
    questionsWithUnclearPractice,
    questionsNotApplicable,
  } = buildData()

  return (
    <Box width='100%'>
      <ResponsiveContainer width='100%' height={300}>
        <ScatterChart
          margin={{
            top: 20,
            right: 20,
            bottom: 20,
            left: 20,
          }}
        >
          <CartesianGrid />
          <XAxis
            dataKey='x'
            type='number'
            tick={{ fill: '#999999' }}
            style={{
              fontSize: '0.75rem',
              fontFamily: 'Lato',
            }}
            domain={[
              0,
              1,
            ]}
          />
          <YAxis
            yAxisId='left'
            tickFormatter={value => data[value]?.title || ''}
            dataKey='y'
            tickCount={7}
            tick={{ fill: '#999999' }}
            style={{
              fontSize: '0.75rem',
              fontFamily: 'Lato',
            }}
          />
          <Scatter yAxisId='left' name='Clear & Good' data={questionsWithGoodPractice} fill='#33A544' />
          <Scatter yAxisId='left' name='Clear & Bad' data={questionsWithBadPractice} fill='#23B5E8' />
          <Scatter yAxisId='left' name='Unclear' data={questionsWithUnclearPractice} fill='#FAA41A' />
          <Scatter yAxisId='left' name='Not Applicable' data={questionsNotApplicable} fill={NOT_APPLICABLE_COLOR} />
        </ScatterChart>
      </ResponsiveContainer>
      <Stack direction='row' justifyContent='center' spacing={1} minHeight={20}>
        <ChartLabel labelText='Clear & Good' bgcolor='#33A544' />
        <ChartLabel labelText='Clear & Bad' bgcolor='#23B5E8' />
        <ChartLabel labelText='Unclear' bgcolor='#FAA41A' />
        <ChartLabel labelText='Not Applicable' bgcolor={NOT_APPLICABLE_COLOR} />
      </Stack>
    </Box>
  )
}

export default React.memo(ChartsPrivacy)
